import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "camera",
  "use": "camera-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"camera\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.284 4l.479-1.337A1 1 0 015.704 2h4.546a1 1 0 01.942.663L11.67 4H15a1 1 0 011 1v8a1 1 0 01-1 1H1a1 1 0 01-1-1V5a1 1 0 011-1h3.284zm.941.337A1 1 0 014.284 5H1v8h14V5h-3.33a1 1 0 01-.94-.663L10.25 3H5.704l-.479 1.337zM5 9a3 3 0 106 0 3 3 0 00-6 0zm3 2a2 2 0 100-4 2 2 0 000 4zm4.5-5a.5.5 0 000 1h1a.5.5 0 000-1h-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol